import ResetPassword from './container/index';

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/views/Auth/ResetPassword/index.js